import { api } from "./client";

export interface VersionResponse {
  version: string;
  build_sha?: string;
  build_timestamp?: string;
}

export async function getVersion(): Promise<VersionResponse> {
  return api.get<VersionResponse>("/version");
}
